import React  , { Component } from 'react';
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem2,
          PostSliderItem,
          HomeTitle,
          ResponsiveYouTubeIframe,
          ActivaImg        } from '../../Components/UI/UI';

import SimpleSlider from '../../Components/SimpleSlider/SimpleSlider';


import { agentsArr } from "../../Data/Data";
import { getWeather, isMobile } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./ChristianPage.css"



const sliderSettings = {
  dots: false,
  autoplay: true,
  // lazyLoad: 'ondemand',
  infinite: true,
  lazyLoad: "ondemand",
  cssEase: 'linear',
  slidesToShow: 3,
  slidesToScroll: 3,

  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },

    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  
};


class ChristianPage extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,
    vidId: "3ahATaKkhBk"

  }

  componentDidMount () {

    getWeather((Weather)=>{
    
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }

  

  setVideo = (vidId) => {
    this.setState({vidId});
  }
  


  render(){
    // get all posts 
    const  posts = [ ...agentsArr ] ;

    const itinerariesArr = posts.filter((o , i )=>{
      return o.ctg === 'itineraries' && o.isDouble === false;
   })

    // get non video posts and culinary posts
    const christianPosts = posts.filter((o , i )=>{
       return o.ctg === 'christian' && o.isDouble === false;
    })

    // const thingsToDoPosts = [ ...posts ];

    const postsHtml = christianPosts.map( (o,i) => {
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
        let url = null;
        let component = null;


        
        if (o.isVid === true) {
         
          url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
          component = <VideoSliderItem2  
                        key={i}
                        title={o.title}
                        desc={""}
                        img= {o.img}
                        link={url}
                        cssClass={cssClass}
                        vidId={o.vidId}
                        click={()=>{
                          this.setVideo(o.vidId)
                        }} />
        }else {
          url  = "/Posts/" + o.ctg  + '/' + o.id;
          component = <PostSliderItem  
                          key={i}
                          title={o.title}
                          desc={""}
                          img= {o.img}
                          link={url}
                          cssClass={cssClass} />
        }

        return component;
        
    });

    const itinerariesmObileArr = [];
    if ( itinerariesArr.length > 0 ) {

          var size = 1;
  
           if ( this.state.width < 1000 ) {
              size = 2;
          } 

          if ( this.state.width < 600 ) {
              size = 4;
          }
          while(itinerariesArr.length) {
              itinerariesmObileArr.push( itinerariesArr.splice(0,size));
          }
    }

    let itinerariesPostsHtml = null;
    if ( itinerariesmObileArr.length > 0 ) {
       itinerariesPostsHtml = itinerariesmObileArr.map((arr , i)=>{
         
         return arr.map((o , i) =>  {

           var title = o.title;
           const url =  "/Posts/" + o.ctg  + '/' + o.id;

           // if ( this.state.width < 1000 ){
           //     title = o.title + ' >';
           // } 
              return <PostSliderItem  
                       key={i}
                       title={title}
                       desc={o.sml_desc}
                       doBlank={true}
                       img= {o.img}
                       link={url} />
                     
         });
       });
     
       itinerariesPostsHtml = itinerariesPostsHtml.map( (o,i) => {
         // console.log(o);
         return <div>{o}</div>;
       });
       
     }

    return(
      <div className="inner-page align-center page-christian">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">

        <LazyLoad height={200} once offset={400}>

        <section className="home-section home-section-padding weather-section ac-jerusalem-posts" id="jerusalem-posts">
          <div className="container">
            <HomeTitle>
              ITINERARIES
            </HomeTitle>
              { isMobile() && this.state.imageState9 ? <ActivaImg src={"PostCarousel/video_mob/activa-img-jerusalem.jpg"} click={this.playVideo9}/> : <ResponsiveYouTubeIframe vidId={"FYtk8JMMZRE"} />}
            <div className="clear"></div>
            
            <div className="video-slider-wrapper">
              <SimpleSlider settings={sliderSettings}>
                {itinerariesPostsHtml}
              </SimpleSlider>
            </div>

            <div className="clear"></div>
          </div>
        </section>
        </LazyLoad>

        <LazyLoad height={200} once offset={100}>
          <section  className="home-section home-section-padding weather-section" id="expore-jerusalem">
            <div className="container">
              <HomeTitle>
               Things To Do
              </HomeTitle>
              { isMobile() && this.state.imageState4 ? <ActivaImg src={"PostCarousel/video_mob/activa-img-north.jpg"} click={this.playVideo4}/> : <ResponsiveYouTubeIframe vidId={this.state.vidId} />}
              <div className="clear"></div>
              
              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {postsHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>
            {/* <HomeDeals /> */}
        </section>
        <Footer />
      </div>
    )
  }

}



export default ChristianPage


// WEBPACK FOOTER //
// ./src/Pages/ChristianPage/ChristianPage.js